<template>
  <div class="memberList">
    <v-card class="cardWrap">
      <CardTitle title="当日連絡事項設定" />
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        class="elevation-1"
        sort-by="memberNo">
        <template v-slot:top>
        </template>
        <template v-slot:[`item.editBtn`]="{ item }">
          <v-btn v-if="item.delivery_id" color="green darken-4" text @click="OnEditModal(item)" class="editBtn" :disabled="btn[0].isActive">変更</v-btn>
          <v-btn v-else color="green darken-4" text @click="OnEditModal(item)" class="editBtn" :disabled="btn[1].isActive">登録</v-btn>
        </template>
        <template v-slot:[`item.deleteBtn`]="{ item }">
          <v-btn color="error darken-4" text @click="OnDelete(item)" class="editBtn" :disabled="btn[2].isActive || !item.delivery_id">削除</v-btn>
        </template>
      </v-data-table>
      <!-- <v-pagination
        class="my-2"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        @input="clickPagination"
      ></v-pagination> -->
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="OnAddModal" :disabled="btn[2].isActive">追加</v-btn>
      </v-card-actions> -->
    </v-card>
    <DeliveryModal
      ref="DeliveryModal"
      :dayList="dayList"
      v-on:from-Dialog="CloseOverlay()"
    />
    <RemoveOverlay
      page-name="当日連絡事項"
      @processing="DeleteDelivery"
      @cancel="addOverlay = !addOverlay"
      :process-result="process"
      :OverlaySwitch="addOverlay"
    />
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import DeliveryModal from './modal/DeliveryModal';
import RemoveOverlay from '@/components/overlay/RemoveOverlay';
// import validater from '@/lib/validater';

// import { CODE_MASTER } from '../config';
// サンプルデータ（ポイント残数）
// import SamplePointData from '../../assets/data/sample_point.json';

import { MEMBER_LIST_INITIAL_DISPLAY } from '../../constants/member_list';
import { GET_DELIVERY_LIST } from '../../constants/delivery';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
import { GET_OPERATION_ACCESSES_LIST } from '@/constants/operation_accesses';
import { GET_LOGIN_ADMIN } from '@/constants/login';
import { DELETE_DELIVERY } from '@/constants/delivery';

export default {
    components: {
        CardTitle,
        DeliveryModal,
        RemoveOverlay
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    data () {
        return {
            dayList: [],
            toDay: '',
            endDay: '',
            Itemlist: [],
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '配信日', sortable: false, value: 'delivery_date' },
                { text: '天気及びその他連絡事項', align: 'left', sortable: false, value: 'delivery_contents' },
                { text: '', value: 'editBtn', sortable: false },
                { text: '', value: 'deleteBtn', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            golf_groups: [],
            // ゴルフ場選択の制御
            modeStatus: '',
            golf_code: null,
            golfSelect: [],
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            addOverlay: false,
            fromSetData: {
                delivery_id: '',
                delivery_date: '',
                delivery_contents: ''
            },
            // ログインしている者の情報
            admin: {
                golf_code: '',
                user_div: '',
                user_id: '',
                point_use_type: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '変更', isActive: true },
                { element_id: '002', element_name: '登録', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0107'
            // rules: {
            //     required_golf_course: value => this.isRequired(value) || this.$t('error.validation.required.whenCardNoIs')
            // }
        };
    },
    async created () {
        await this.$apollo.mutate({
            mutation: GET_LOGIN_ADMIN
        }).then(res => {
            this.admin.user_id = res.data.getLoginAdmin.user_id;
            this.admin.user_div = res.data.getLoginAdmin.login.user_div;
            this.admin.golf_code = res.data.getLoginAdmin.login.golf_code;
            return res.data.getLoginAdmin;
        });
        await this.initialFetch();

        this.admin.point_use_type = this.golf_groups[0].point_use_type;

        // システム管理者の場合
        if (this.admin.user_div === 1 && this.admin.point_use_type === 1) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golfSelect.unshift({ golf_code: '', golf_name: '' });
        } else if (this.admin.user_div === 1 && this.admin.point_use_type === 2) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golf_code = this.Itemlist[0].golf_code;
        } else {
        // ゴルフ場担当者
            this.Itemlist = [];
            this.Itemlist.push(this.golfSelect.find(el => el.golf_code === this.admin.golf_code));
            this.golf_code = this.admin.golf_code;
        }

        this.dayList = [];
        this.dayList = this.getSettingDayList(10);
        this.toDay = this.dayList[0];
        this.endDay = this.dayList[9];
        this.getDeliveryList();
        // this.getMember();
        // this.getMessageList();
        await this.getAuthorityByMemberList();
    },
    computed: {
        // formatedDate: function () {
        //     return function (pdate) {
        //         pdate = this.addHyphen(pdate);
        //         return pdate;
        //     };
        // }
    },
    methods: {
        initialFetch () {
            return this.$apollo.mutate({
                mutation: MEMBER_LIST_INITIAL_DISPLAY,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                this.golfSelect = res.data.getGolfCourse;
                this.golf_groups = res.data.getGolfGroupByMaster;
            });
        },
        getAuthorityByMemberList () {
            this.$apollo.mutate({
                mutation: GET_OPERATION_ACCESSES_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                let opeList = res.data.GetOperationAccessList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        },
        /** --------------------------------------------
        * 連絡事項設定一覧取得
        * -------------------------------------------- */
        async getDeliveryList () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_DELIVERY_LIST,
                        variables: {
                            toDay: this.toDay,
                            endDay: this.endDay
                        }
                    })
                    .then(res => {
                        this.desserts = [];
                        this.desserts = res.data.getDeliveryList.DeliveryList;
                        // DB上にない日付けがあれば日付けを追加する
                        for (var i = 0; i < this.dayList.length; i++) {
                            if (!this.desserts.some(el => el.delivery_date === this.dayList[i])) {
                                this.desserts.push({
                                    delivery_id: '',
                                    delivery_date: this.dayList[i],
                                    delivery_contents: '',
                                    valid_flag: 1
                                });
                            }
                        }
                        // 日付けを追加された場合があるので日付順にソートする
                        this.desserts.sort(function (a, b) {
                            if (a.delivery_date > b.delivery_date) {
                                return 1;
                            } else {
                                return -1;
                            }
                        });
                        this.pageCount = Math.ceil(this.desserts.length / this.limit_rows);
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 削除
         * ---------------------------------------------- */
        DeleteDelivery: async function () {
            try {
                await this.$apollo.mutate({
                    mutation: DELETE_DELIVERY,
                    variables: {
                        delivery_id: this.fromSetData.delivery_id,
                        delivery_date: this.fromSetData.delivery_date
                    }
                }).then(res => {
                    this.process.result = '1';
                    this.process.resultText = this.$t('result.success.remove');
                    this.dayList = [];
                    this.dayList = this.getSettingDayList(10);
                    this.toDay = this.dayList[0];
                    this.endDay = this.dayList[9];
                    this.getDeliveryList();
                });
            } catch (error) {
                this.process.result = '1';
                this.process.resultText = this.$t('result.error.remove');
                this.error = error;
            }
        },
        /** ----------------------------------------------
        * 追加ボタン押下時の処理
        * ---------------------------------------------- */
        // OnAddModal: function () {
        //     this.$refs.DeliveryModal.AddModal();
        // },
        /** ----------------------------------------------
        * 変更ボタン押下時の処理
        * @item 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        OnEditModal: function (item) {
            this.$refs.DeliveryModal.EditModal(item);
        },
        /** ----------------------------------------------
        * 削除ボタン押下時の処理
        * @item 削除時に使用する
        * ---------------------------------------------- */
        OnDelete: function (item) {
            this.addOverlay = !this.addOverlay;
            this.fromSetData.delivery_id = item.delivery_id;
            this.fromSetData.delivery_date = item.delivery_date;
        },
        /** ----------------------------------------------
        * オーバーレイが閉じたときの処理
        * ---------------------------------------------- */
        CloseOverlay: function () {
            this.dayList = [];
            this.dayList = this.getSettingDayList(10);
            this.toDay = this.dayList[0];
            this.endDay = this.dayList[9];
            this.getDeliveryList();
        }
    }
};
</script>

<style scoped>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 195px;
}

</style>
